import React from "react";
import StoresContext from "../../context/storesContext";

const WithEnergyStores = Component => {
  return class extends React.Component {
    render() {
      return (
        <StoresContext.Consumer>
          {({ stores }) => <Component stores={stores.energy} {...this.props} />}
        </StoresContext.Consumer>
      );
    }
  };
};

export default WithEnergyStores;
